module.exports = __webpack_public_path__ + "assets/img/addTask_btn3.54a6d93c.png";